import { AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';

import { NavigationBar } from './NavigationBar.jsx';

export const PageLayout = (props) => {
    /**
     * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
     * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
     * only render their children if a user is authenticated or unauthenticated, respectively.
     */
    return (
        <>
            {/* <h3>
                <center>BioMADE Telescope - Supply Chain Resiliency</center>
            </h3> */}

            <UnauthenticatedTemplate>
                <NavigationBar />
            </UnauthenticatedTemplate>
            
            {props.children}
            <br />
            
            <AuthenticatedTemplate>
                {/* <footer>
                    <center>
                        How did we do?
                        <a
                            href="https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbR_ivMYEeUKlEq8CxnMPgdNZUNDlUTTk2NVNYQkZSSjdaTk5KT1o4V1VVNS4u"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {' '}
                            Share your experience!
                        </a>
                    </center>
                </footer> */}
            </AuthenticatedTemplate>
        </>
    );
}